export const permissionsDocumentsFull = ["documents-full", "everything-full"];
